import {
  initClientTelemetry,
  initServerTelemetry,
  type TelemetryClient,
} from "../core/client.js";
import type { TelemetryFramework } from "../core/types.js";
import { mergeTelemetryConfig } from "../di/merge-config.js";
import type { TelemetryFrameworkAdapter } from "../schema/di.js";
import { normalizeSetupInput } from "./normalize.js";
import type { TelemetryPlan } from "./plan.js";

function platformIdToAdapter(id: TelemetryFramework): TelemetryFrameworkAdapter {
  return id === "browser" ? "generic" : id;
}

function mapFramework(
  adapter: TelemetryFrameworkAdapter | TelemetryFramework | undefined,
): TelemetryFramework {
  if (!adapter || adapter === "generic") return "browser";
  if (adapter === "browser") return "browser";
  return adapter as TelemetryFramework;
}

export function createRuntimeFromPlan(
  plan: TelemetryPlan,
  runtime: "client" | "server",
): TelemetryClient {
  const di = normalizeSetupInput(plan.moduleInput);

  const merged = mergeTelemetryConfig(
    di.config,
    runtime === "client" ? di.client : di.server,
    runtime,
  );

  const client =
    runtime === "client"
      ? initClientTelemetry({ ...merged, sentryRegistry: plan.sentryRegistry })
      : initServerTelemetry({ ...merged, sentryRegistry: plan.sentryRegistry });

  client.setFramework(
    mapFramework(di.framework ?? platformIdToAdapter(plan.platform.id)),
  );
  return client;
}
